import React, { useState } from 'react'
import Slider from 'react-slick'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Icons from '../../Constants/Icons'

const SliderComponent = () => {
  const [activeIndex, setActiveIndex] = useState(0)

  const slides = [
    {
      name: 'Johnathan Katz',
      image: '',
      quote:
        'MaisonsDirect was able to list my home and save me thousands in broker fees. My home sold faster than I could have imagined. '
    },
    {
      name: 'Joey Russo',
      image: '',
      quote:
        ' I received a higher cash offer than many of the other ads I’ve responded to. These guys are the real deal.'
    },
    {
      name: 'Chris Angelopoulos',
      image: '',
      quote:
        'Jenny and her team are changing the game. Smooth transaction and more money in my pocket. '
    },
    {
      name: 'Zhang We',
      image: '',
      quote:
        'Maisons Direct was able to list my home on the MLS within 24 hours and we received multiple offers to choose from. Highly recommend working with their brokers. '
    }
  ]
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3, 
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '0',
    prevArrow: <FaArrowLeft />,
    nextArrow: <FaArrowRight />,
    autoplay: true,
    autoplaySpeed: 3000,
    afterChange: current => setActiveIndex(current),
    responsive: [

      {
        breakpoint: 991, 
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: false // Disable centering for smaller screens
        }
      }
    ]
  }

  return (
    <div className='slider-container'>
      <div className='section-title'>
        <h1>REVIEWS</h1>
      </div>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={
              index === activeIndex ? 'active-slide' : 'inActive-slide'
            }
          >
            <p>{slide.quote}</p>
            ⭐⭐⭐⭐⭐
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                textAlign: 'left',
                justifyContent: 'start'
              }}
            >
              <img src={Icons.White_collar} style={{ height: '50px' }} />
              <h6 style={{ fontSize: '15px', margin: '0px' }}>{slide.name}</h6>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default SliderComponent
